import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { FocusEvent } from 'react';
import { useCallback } from 'react';

export const useValidateOnBlur = (type: string, isValidateEmptyValue = false) => {
  const { trigger } = useFormContext();

  return useCallback(
    <T extends HTMLElement>(event?: FocusEvent<T>) => {
      if ((event?.currentTarget instanceof HTMLInputElement && event.currentTarget.value) || isValidateEmptyValue) {
        return trigger(type);
      }
    },
    [trigger, type, isValidateEmptyValue],
  );
};
